import type { IR2Attachment, IR2MessageMeta } from '@common/types/api/r2-types';
import { T_MESSAGE_SENDER } from '@core/constants/chat.constants';

interface IChatMessageBase
{
    sender: T_MESSAGE_SENDER;
    value: string;
    msg_id?: string;
    /** Unix timestamp in ms; present for messages that carry one. */
    createdAt?: number;
    /** API name of the model that produced the assistant response. */
    model?: string;
    /** R2 tokens consumed by the assistant response. */
    tokensUsage?: number;
    isPending?: boolean;
    // Stable identity for UI list tracking; see IChatOfficeMessageBase.localId.
    localId?: string;
}

export interface IChatMessageAudio
{
    base64: string;
    mimeType: string;
    size: number;
    durationMs: number;
    fileName: string;
}

export interface IChatMessageUser extends IChatMessageBase
{
    sender: 'USER';
    meta?: IR2MessageMeta;
    attachments?: IR2Attachment[];
    audio?: IChatMessageAudio;
}

export interface IChatMessageBot extends IChatMessageBase
{
    sender: 'ASSISTANT';
    options: IChatMessageBotOption;
    attachments?: IR2Attachment[];
}

export type IChatMessage = IChatMessageUser | IChatMessageBot;

export enum eMessageBotPlanType
{
    TRIAL = 'TRIAL',
    BALANCE = 'BALANCE',
}

export interface IChatMessageBotOption
{
    plan: {
        availableTokens: number;
        type: eMessageBotPlanType;
    };
    usedTotalTokens: number;
    usages: IChatMessageBotUsage[];
    attachments?: IR2Attachment[];
}

export interface IChatMessageBotEmbed
{
    image: {
        content: string;
        url: string;
        mimeType: string;
    };
}

export interface IChatMessageBotUsage
{
    model: string;
    promptTokens: number;
    completionTokens: number;
    totalTokens: number;
}

export interface IChatMessageFromHistory
{
    role: T_MESSAGE_SENDER;
    content: string;
}
